var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _vm.sail
        ? _c("div", { staticClass: "form-box" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-content pb-2" }, [
              _c("div", { staticClass: "table-form table-responsive" }, [
                _c("table", { staticClass: "table" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.basePath + "/sails/" + _vm.sail.id,
                            },
                          },
                          [_vm._v("#" + _vm._s(_vm.sail.id))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.sail.cruise.name))]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm._f("ddMMyyyyHHmm")(_vm.sail.sailDate))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.sail.seaTour.tourCode))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.sail.totalRoomCount))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.sail.availableRoomCount))]),
                      _vm._v(" "),
                      _c("th", [
                        _vm.sail.seaTour.visaRequired
                          ? _c(
                              "span",
                              {
                                staticClass: "badge badge-warning py-1 px-2",
                                staticStyle: { color: "white" },
                              },
                              [
                                _vm._v(
                                  "\n              Vize Gerekli\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.sail.saleOpen
                        ? _c("th", [
                            _c(
                              "span",
                              { staticClass: "badge badge-success py-1 px-2" },
                              [_vm._v("Satışa Açık")]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.sail.saleOpen
                        ? _c("th", [
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-warning py-1 px-2",
                                staticStyle: {
                                  "background-color": "#d32727",
                                  color: "white",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Satışa Kapalı\n          "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [_c("h3", { staticClass: "title" }, [_vm._v("Sefer Bilgisi")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("Adı")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tarih")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tur Kodu")]),
        _vm._v(" "),
        _c("th", [_vm._v("Toplam Oda")]),
        _vm._v(" "),
        _c("th", [_vm._v("Müsait Oda")]),
        _vm._v(" "),
        _c("th", [_vm._v("Vize Durumu")]),
        _vm._v(" "),
        _c("th", [_vm._v("Satış Durumu")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }